import "data/yup-validation";
import { Form, Formik } from "formik";
import React from "react";
import { Grid } from "@mui/material";
import * as yup from "yup";
import { US_PHONE_MASK } from "utils/phone";
import {
  InputWithErrorLabel,
  MaskedInputWithErrorLabel,
} from "components/haven-design/form/inputs";
import { Button } from "components/haven-design";
import { TosCheckbox } from "components/haven-design/form/checkbox";
import { LoneGrid } from "components/login/components/shared-components";

export type InitialUserData = {
  firstName: string;
  lastName: string;
  title: string;
  directPhone: string;
  terms?: boolean;
}

type Props = {
  onSubmit: (values: InitialUserData) => void;
  initialData: InitialUserData;
  isSending?: boolean;
}

const schema = yup.object().shape({
  firstName: yup.string().required(),
  lastName: yup.string().required(),
  directPhone: yup.string().validPhoneNumber("Invalid phone number").nullable(),
  title: yup.string().nullable(),
  terms: yup.boolean().oneOf([true], "Must be checked to submit"),
});

export const NewUserForm: React.FC<Props> = (props) => (
  <Formik
    enableReinitialize
    initialValues={props.initialData}
    onSubmit={(values) => {
      props.onSubmit(values);
    }}
    validationSchema={schema}
    render={({ isSubmitting }) => (
      <Form>
        <Grid container spacing={2} justifyContent="center">
          <Grid size={{ md: 6 }}>
            <InputWithErrorLabel label="First Name" name="firstName" type="text" />
          </Grid>
          <Grid size={{ md: 6 }}>
            <InputWithErrorLabel label="Last Name" name="lastName" type="text" />
          </Grid>
        </Grid>

        <Grid container spacing={2} justifyContent="center">
          <Grid size={{ md: 6 }}>
            <MaskedInputWithErrorLabel
              label="Phone"
              name="directPhone"
              mask={US_PHONE_MASK}
              guide={false}
            />
          </Grid>
          <Grid size={{ md: 6 }}>
            <InputWithErrorLabel name="title" label="Title" type="text" />
          </Grid>
        </Grid>
        <LoneGrid>
          <TosCheckbox name="terms" />
        </LoneGrid>
        <LoneGrid><br/></LoneGrid>
        <LoneGrid>
          <Button
            disabled={isSubmitting && !!props.isSending}
            size="L"
            color="primary"
            type="submit"
          >
            {isSubmitting ? "Submitting" : "Submit"}
          </Button>
        </LoneGrid>
      </Form>
    )}
  />
);
